import StoneAdd from './StoneAdd'

export default StoneAdd
